import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PurchaseOrders_ds_get_orderlines_by_orderId_linenumberService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { orderId: number, linenumber: number }): 
  Promise<{ result: { OrderId?: number, LineNumber?: number, MaterialId?: number, Order?: { ProjectId?: number } } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.orderId)) {
      $missingRequiredInParams.push('\'orderId\'');
    }
    if (isNil($inParams.linenumber)) {
      $missingRequiredInParams.push('\'linenumber\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      orderId: number, linenumber: number    }) {
        if(isNil($inParams.orderId)) {
          return true; 
        }
        if(isNil($inParams.linenumber)) {
          return true; 
        }
      return false;
    }
}
